import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { CitationSource } from 'types/chat-message'
import { useOpenSource } from 'components/notebook/DocumentPreviewContext'

type AttachmentCitationProps = {
  num: string
  source?: CitationSource
}

/**
 * Inline citation for a user-uploaded document ([att:N]): a paperclip pill that
 * sets it apart from remote sources, linking out when the source carries a url.
 */
export const AttachmentCitation = ({ num, source }: AttachmentCitationProps) => {
  const openSource = useOpenSource()
  const badge = (
    <span className="mx-px inline-flex items-center gap-0.5 rounded-full bg-muted px-1 align-super text-[10px] font-bold text-muted-foreground">
      <OdinIcon icon={['fas', 'paperclip']} className="h-2.5 w-2.5" />
      {num}
    </span>
  )

  if (source?.url) {
    return (
      <a
        href={source.url}
        target="_blank"
        rel="noopener noreferrer"
        title={source.name}
        // ! l'url memorizzato e nudo: si scambia con uno firmato al click
        onClick={(event) => {
          event.preventDefault()
          void openSource(source)
        }}
        className="no-underline"
      >
        {badge}
      </a>
    )
  }

  return <span title={source?.name}>{badge}</span>
}
